import { render, staticRenderFns } from "./WizardGrid.vue?vue&type=template&id=87b74410"
import script from "./WizardGrid.vue?vue&type=script&lang=js"
export * from "./WizardGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports